import { CLOUDFLARE_ACCOUNT_HASH } from '../env';
import { formatUrl } from './transformer';
export var defaultBaseUrl = "https://images.influitive.com/cdn-cgi/imagedelivery/".concat(CLOUDFLARE_ACCOUNT_HASH);
export var publicImageUrl = function publicImageUrl(id) {
  return formatUrl(id, defaultBaseUrl);
};